import {
  queryWorkPostApplicationApi,
  setWorkPostApplicationCheckStateApi,
  setPostRecommRuleConfigApi,
  addEnterpriseApi,
  deleteEnterpriseApi,
  updateEnterpriseApi,
  queryEnterpriseApi,
  getEnterpriseByIdApi,
  addWorkPostApi,
  deleteWorkPostApi,
  updateWorkPostApi,
  setWorkPostMsgApi,
  getWorkPostByIdApi,
  queryWorkPostApi,
  addWorkPostQuitApi,
  queryWorkPostQuitApi,
  queryWageAndBonusRecordsApi,
  queryUserWorkPostApi,
  getJxtHomePageStatisticsApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  查询工作岗位应聘信息
  async queryWorkPostApplicationAction(context, param) {
    const res = await queryWorkPostApplicationApi(param)
    return res
  },
  //  设置工作岗位应聘审核状态
  async setWorkPostApplicationCheckStateAction(context, param) {
    const res = await setWorkPostApplicationCheckStateApi(param)
    return res
  },
  //  设置岗位推荐规则配置
  async setPostRecommRuleConfigAction(context, param) {
    const res = await setPostRecommRuleConfigApi(param)
    return res
  },
  //  添加企业信息
  async addEnterpriseAction(context, param) {
    const res = await addEnterpriseApi(param)
    return res
  },
  //  删除企业信息
  async deleteEnterpriseAction(context, param) {
    const res = await deleteEnterpriseApi(param)
    return res
  },
  //  更新企业信息
  async updateEnterpriseAction(context, param) {
    const res = await updateEnterpriseApi(param)
    return res
  },
  //  查询企业信息
  async queryEnterpriseAction(context, param) {
    const res = await queryEnterpriseApi(param)
    return res
  },
  //  根据id获取企业信息
  async getEnterpriseByIdAction(context, param) {
    const res = await getEnterpriseByIdApi(param)
    return res
  },
  //  添加工作岗位
  async addWorkPostAction(context, param) {
    const res = await addWorkPostApi(param)
    return res
  },
  //  删除工作岗位
  async deleteWorkPostAction(context, param) {
    const res = await deleteWorkPostApi(param)
    return res
  },
  //  更新工作岗位
  async updateWorkPostAction(context, param) {
    const res = await updateWorkPostApi(param)
    return res
  },
  //  设置工作岗位信息
  async setWorkPostMsgAction(context, param) {
    const res = await setWorkPostMsgApi(param)
    return res
  },
  //  根据id获取工作岗位
  async getWorkPostByIdAction(context, param) {
    const res = await getWorkPostByIdApi(param)
    return res
  },
  //  查询工作岗位
  async queryWorkPostAction(context, param) {
    const res = await queryWorkPostApi(param)
    return res
  },
  //  添加岗位离职
  async addWorkPostQuitAction(context, param) {
    const res = await addWorkPostQuitApi(param)
    return res
  },
  //  查询岗位离职
  async queryWorkPostQuitAction(context, param) {
    const res = await queryWorkPostQuitApi(param)
    return res
  },
  //  查询工资和分红记录
  async queryWageAndBonusRecordsAction(context, param) {
    const res = await queryWageAndBonusRecordsApi(param)
    return res
  },
  //  查询用户工作岗位
  async queryUserWorkPostAction(context, param) {
    const res = await queryUserWorkPostApi(param)
    return res
  },
  //  查询商家后台吉祥天首页统计
  async getJxtHomePageStatisticsAction(context, param) {
    const res = await getJxtHomePageStatisticsApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
